export default "__VITE_ASSET__BFpj4QQC__"